import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdControlsSuspense } from "api/generated/users/users";

export function useControlsForUserQuery(userId: number) {
    return useGetUsersUserIdControlsSuspense(userId, undefined, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
